var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M20.614 6.643c.276-.54.918-.788 1.486-.556l4.714 1.92c.447.181.739.619.739 1.106v4.058h.37a.79.79 0 01.791.791v4.775l4.433 6.393c.153.22.246.475.273.74l.009.16v12.226a3.18 3.18 0 011.566 2.564L35 41H13c0-1.17.631-2.191 1.571-2.744V26.031c0-.322.099-.637.282-.901l4.433-6.393v-4.775a.79.79 0 01.79-.79l.405-.001V7.193c0-.102.013-.203.039-.3l.047-.145zm1.606 1.324a.318.318 0 00-.439.3v4.677h4.473V9.828a.324.324 0 00-.151-.274l-.05-.026z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
